module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Browser",
    class: {
      'Browser--suiteIsUnoccupied': _vm.suiteIsUnoccupied
    }
  }, [(_vm.suiteIsUnoccupied) ? _c('div', {
    staticClass: "Browser-messages"
  }, [_c('messages', {
    ref: "messages",
    attrs: {
      "content": [],
      "alt-colors": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showBrowserHeader) ? _c('div', {
    staticClass: "Browser-header"
  }, [(_vm.animal) ? _c('div', {
    staticClass: "Browser-icon",
    style: ({
      'background-image': ("url(" + (_vm.animal.image) + ")")
    })
  }) : _vm._e(), _vm._v(" "), (_vm.animal) ? _c('div', {
    staticClass: "Browser-title"
  }, [_vm._v("\n      " + _vm._s(_vm.animal.name) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Browser-suiteInfo"
  }, [_c('div', {
    staticClass: "Browser-suiteInfoContent"
  }, [_c('p', {
    staticClass: "Browser-suiteTitle"
  }, [_vm._v("Suite")]), _vm._v(" "), _c('p', {
    staticClass: "Browser-suiteNumber"
  }, [_vm._v(_vm._s(_vm.suite.suiteNumber))])])])]) : _vm._e(), _vm._v(" "), (!_vm.animal.available) ? _c('status-badge', {
    staticClass: "Browser-statusBadge"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Browser-content"
  }, [_c('div', {
    staticClass: "Browser-container"
  }, [_c('div', {
    staticClass: "Browser-handle Browser-handle--top"
  }, [_c('icon', {
    staticClass: "Browser-handleIcon",
    attrs: {
      "name": "pull-tab-top",
      "width": "72.36px",
      "height": "13.09px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Browser-windowBorder",
    class: {
      'Browser-windowBorder--showColor': this.showCircleBorder
    }
  }, [_c('div', {
    staticClass: "Browser-window"
  }, [(_vm.animals.length > 1) ? _c('div', {
    staticClass: "Browser-selectorButton",
    on: {
      "click": _vm.goToAttract
    }
  }, [_c('icon', {
    staticClass: "Browser-selectorButtonIcon",
    attrs: {
      "name": "home",
      "width": "21.98px",
      "height": "20.14px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Browser-selectorButtonLabel"
  }, [_vm._v("Change Pet")])], 1) : _vm._e(), _vm._v(" "), _c('menu-component'), _vm._v(" "), _c('div', {
    staticClass: "Browser-windowContent"
  }, [_c('transition', {
    attrs: {
      "name": "Browser-windowContent-"
    }
  }, [_c('router-view', {
    staticClass: "Browser-windowContentItem"
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "Browser-handle Browser-handle--bottom"
  }, [_c('icon', {
    staticClass: "Browser-handleIcon",
    attrs: {
      "name": "pull-tab-bottom",
      "width": "72.36px",
      "height": "13.09px"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a192e8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Browser.vue
// module id = 370
// module chunks = 1